export default __webpack_public_path__ + "static/media/snow-night.c1ec3b04.svg";